import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersRoutingModule } from './users-routing.module';
import { CreateComponent } from './create/create.component';
import {UsersComponent} from './users.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Trip2ThemeModule} from '../../trip2-theme/trip2-theme.module';
import {AgGridModule} from 'ag-grid-angular';
import {ChangePasswordModule} from '../A2-utils/change-password/change-password.module';
import { DeleteComponent } from './delete/delete.component';
import {MultiSelectDropdownModule} from '../A2-utils/multi-select-dropdown/multi-select-dropdown.module';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { GridComponentsModule } from '../A2-utils/grid-components/grid-components.module';
import { DirectivesModule } from '../../directives/directives.module';
import { UserFormComponent } from './user-form/user-form.component';
import {PayorFacilitiesModule} from '../payors/payor-facilities/payor-facilities.module';
import {AutoCompleteFacilitiesModule} from '../A2-utils/auto-complete-facilities/auto-complete-facilities.module';
import { TextMaskModule } from 'angular2-text-mask';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

@NgModule({
  imports: [
      AgGridModule.withComponents([BooleanCheckComponent]),
      GridComponentsModule,
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      Trip2ThemeModule,
      UsersRoutingModule,
      ChangePasswordModule,
      MultiSelectDropdownModule,
      DirectivesModule,
      AutoCompleteFacilitiesModule,
      PayorFacilitiesModule,
      TextMaskModule,
      AngularMultiSelectModule
  ],
  declarations: [
      CreateComponent,
      UsersComponent,
      DeleteComponent,
      UserFormComponent
  ]
})
export class UsersModule { }



// WEBPACK FOOTER //
// ./src/app/pages/users/users.module.ts